import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Layout from '../layout/Layout';
import Loader from './Loader';

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // 如果正在加载，显示加载中
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f8fa]">
        <Loader />
      </div>
    );
  }

  // 如果未认证，重定向到登录页
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果已认证，渲染子路由，并包装在布局组件中
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute;